import React from 'react';
import './Webinar.css';

const Webinar = () => {
  return (
    <section className="webinar-section">
      <div className="webinar-container">
        <div className="webinar-header">
          <h2 className="webinar-title">DÉCOUVREZ LA MÉTHODE PROSPERIAN</h2>
          <h3 className="webinar-subtitle-header">IA + EXPERTISE HUMAINE</h3>
        </div>
        
        <div className="webinar-content">
          <div className="webinar-text">
            <p className="webinar-description">
              Participez à notre webinaire hebdomadaire pour comprendre comment notre approche hybride 
              révolutionne la prospection B2B. Posez vos questions à nos experts en direct.
            </p>
            
            <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer">
              <button className="webinar-button">RÉSERVER MA PLACE</button>
            </a>
          </div>
          
          <div className="webinar-video-container">
            <div className="webinar-video-placeholder">
              <div className="video-play-button">
                <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 5V19L19 12L8 5Z" fill="white"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Webinar; 